export const ConfigDataSidebarData = [
  {
    title: "SUPPORT NUMBER",
    link: "supportNumber",
  },
  {
    title: "SUPPORT EMAIL",
    link: "supportEmail",
  },
  {
    title: "ADMIN EMAIL",
    link: "adminEmail",
  },

  {
    title: "ADDITIONAL DISCOUNT",
    subNav: [
      {
        title: "STUDENT",
        path: "student",
        cName: "sub-nav",
      },
      {
        title: "PAMPLET",
        path: "pamplet",
        cName: "sub-nav",
      },
      {
        title: "INFLUENCER",
        path: "influencer",
        cName: "sub-nav",
      },
      {
        title: "REFERRAL",
        path: "referral",
        cName: "sub-nav",
      },
    ],
  },

  {
    title: "INVOICE RECEIVED EMAIL",
    link: "invoiceReceivedEmail",
  },
  {
    title: "LIVE VIDEO SETTING",
    link: "liveVideoSetting",
  },
  {
    title: "TAX SETTING",
    link: "taxSetting",
  },
  {
    title: "INSTALLMENT SETTING",
    link: "installmentSetting",
  },
  {
    title: "ISSUE TYPE",
    subNav: [
      {
        title: "ADD ISSUE",
        path: "addIssueType",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editDeleteIssueType",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SHIPPING CHARGE",
    subNav: [
      {
        title: "ADD CHARGES",
        path: "addCharges",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editDeleteCharges",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "QUESTION CONFIG",
    subNav: [
      {
        title: "ADD",
        path: "addQuestionConfig",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editDeleteQuestionConfig",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "APP VERSION CONTROL",
    link: "appVersionControl",
  },
  {
    title: "OTP SETTING",
    link: "otpSetting",
  },
  {
    title: "SERVERS",
    link: "serversList",
  },
  {
    title: "QUESTION ISSUE",
    subNav: [
      {
        title: "ADD",
        path: "addQuestionIssue",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editQuestionIssue",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "WHATSAPP MESSAGE",
    link: "whatsappMsg",
  },
  {
    title: "WHATSAPP IMAGE",
    link: "whatsappImg",
  },
  {
    title: "LEAD ORDERS SEARCH",
    link: "leadOrdersSearch",
  },
  {
    title: "WHATSAPP SHOOT DATA",
    link: "whatsappShotData",
  },
  {
    title: "ADD BBB PDF AND VIDEO",
    link: "addBBBPDFandVideo",
  },
  {
    title: "ADD DATA TO REPORTS",
    link: "addDataToReports",
  },
  {
    title: "Email Campaign",
    subNav: [
      {
        title: "ADD MAIL ",
        path: "addMailCampaign",
        cName: "sub-nav",
      },

      {
        title: "Email Analysis",
        path: "editDeleteEmailCamp",
        cName: "sub-nav",
      },
      // {
      //   title: "Mail Notification ",
      //   path: "mailPushNotification",
      //   cName: "sub-nav",
      // },
    ],
  },
  {
    title: "Campaign Management",
    subNav: [
      {
        title: "ADD",
        path: "addCampaign",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editDeleteCampaign",
        cName: "sub-nav",
      },
    ],
  },
  // {
  //   title: "Push Notifications",
  //   link: "sendPushNotification",
  // },
  {
    title: "Global Special Discount",
    link: "globalSpecialDiscount",
  },
  {
    title: "User KYC",
    link: "userKycDetails",
  },
  {
    title: "Verify User Details",
    link: "verifyuserDetails",
  },
  {
    title: "WhatsApp Template Status",
    link: "whatsAppTemplateStatus",
  },
  {
    title: "CRON MANAGEMENT",
    link: "cronManagement",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];
export const ConfigEmpSidebarData = [
  {
    title: "EMPLOYEE DETAILS",
    subNav: [
      {
        title: "Dashboard",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "My Profile",
        path: "userProfile",
        cName: "sub-nav",
      },
      {
        title: "Policies",
        path: "policy",
        cName: "sub-nav",
      },
      {
        title: "KRA/KPI",
        path: "kraKpi",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SUPPORT NUMBER",
    link: "supportNumber",
  },
  {
    title: "SUPPORT EMAIL",
    link: "supportEmail",
  },
  {
    title: "ADMIN EMAIL",
    link: "adminEmail",
  },

  {
    title: "ADDITIONAL DISCOUNT",
    subNav: [
      {
        title: "STUDENT",
        path: "student",
        cName: "sub-nav",
      },
      {
        title: "PAMPLET",
        path: "pamplet",
        cName: "sub-nav",
      },
      {
        title: "INFLUENCER",
        path: "influencer",
        cName: "sub-nav",
      },
      {
        title: "REFERRAL",
        path: "referral",
        cName: "sub-nav",
      },
    ],
  },

  {
    title: "INVOICE RECEIVED EMAIL",
    link: "invoiceReceivedEmail",
  },
  {
    title: "LIVE VIDEO SETTING",
    link: "liveVideoSetting",
  },
  {
    title: "TAX SETTING",
    link: "taxSetting",
  },
  {
    title: "INSTALLMENT SETTING",
    link: "installmentSetting",
  },
  {
    title: "ISSUE TYPE",
    subNav: [
      {
        title: "ADD ISSUE",
        path: "addIssueType",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editDeleteIssueType",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SHIPPING CHARGE",
    subNav: [
      {
        title: "ADD CHARGES",
        path: "addCharges",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editDeleteCharges",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "QUESTION CONFIG",
    subNav: [
      {
        title: "ADD",
        path: "addQuestionConfig",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editDeleteQuestionConfig",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "APP VERSION CONTROL",
    link: "appVersionControl",
  },
  {
    title: "OTP SETTING",
    link: "otpSetting",
  },
  {
    title: "SERVERS",
    link: "serversList",
  },
  {
    title: "QUESTION ISSUE",
    subNav: [
      {
        title: "ADD",
        path: "addQuestionIssue",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editQuestionIssue",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "WHATSAPP MESSAGE",
    link: "whatsappMsg",
  },
  {
    title: "LEAD ORDERS SEARCH",
    link: "leadOrdersSearch",
  },
  {
    title: "WHATSAPP SHOOT DATA",
    link: "whatsappShotData",
  },
  {
    title: "ADD BBB PDF AND VIDEO",
    link: "addBBBPDFandVideo",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "Email Campaign",
    subNav: [
      {
        title: "ADD MAIL ",
        path: "addMailCampaign",
        cName: "sub-nav",
      },

      {
        title: "EDIT / DELETE",
        path: "editDeleteEmailCamp",
        cName: "sub-nav",
      },
      // {
      //   title: "Mail Notification ",
      //   path: "mailPushNotification",
      //   cName: "sub-nav",
      // },
    ],
  },
  {
    title: "Campaign Management",
    subNav: [
      {
        title: "ADD",
        path: "addCampaign",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editDeleteCampaign",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "WhatsApp Template Status",
    link: "whatsAppTemplateStatus",
  },
  {
    title: "CRON MANAGEMENT",
    link: "cronManagement",
  },
  // {
  //   title: "Push Notifications",
  //   link: "sendPushNotification",
  // },
];
